import React, { Dispatch, SetStateAction } from 'react';
import styles from './pagination.css';
import PaginationRow from './paginationLayouts';

interface PaginationProps {
  /** Defines the layout for the Paginaion is added to */
  layout?: 'tab' | 'page';
  /** Current page number */
  currentPage: number;
  /** Total items shown per page */
  itemsPerPage: number;
  /** Total number of items */
  totalItems: number;
  /** Pass page change event from parent component. */
  setPage: (arg: number) => void | Dispatch<SetStateAction<number>>;
}

/**
 * Pagination component
 *
 * @param {PaginationProps} param
 *
 * @returns JSX.ELEMENT
 */
export const Pagination = ({
  layout,
  totalItems,
  setPage,
  currentPage = 0,
  itemsPerPage = 20
}: PaginationProps) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const hasPreviousPage = currentPage > 1;
  const hasNextPage = currentPage < totalPages;

  return (
    <>
      {totalPages === 1 ? null : ( // if only one page
        <div className={styles.pagination}>
          <PaginationRow
            layout={layout}
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            hasPreviousPage={hasPreviousPage}
            hasNextPage={hasNextPage}
            setPage={setPage}
          />
        </div>
      )}
    </>
  );
};

export default Pagination;
